(function (Drupal, $) {
  Drupal.behaviors.inPageNavigation = {
    attach: function (context) {
      $(once("in-page-navigation-wrapper-processed", ".in-page-navigation-wrapper", context))
        .each(function () {
          makeIds();

          tocbot.init({
            tocSelector: "#in-page-nav",
            contentSelector: ".js-toc-content",
            headingSelector: "h2",
            ignoreSelector: ".js-toc-ignore",
            hasInnerContainers: true,
            ignoreHiddenElements: true,
            headingsOffset: 150,
            scrollSmoothOffset: -150,
          });

          function makeIds() {
            // eslint-disable-line
            var content = document.querySelector(".js-toc-content");
            var headings = content.querySelectorAll("h1, h2, h3, h4, h5, h6");
            var headingMap = {};

            Array.prototype.forEach.call(headings, function (heading) {
              var id = heading.id
                ? heading.id
                : heading.textContent
                    .trim()
                    .toLowerCase()
                    .split(" ")
                    .join("-")
                    .replace(/[!@#$%^&*():]/gi, "")
                    .replace(/\//gi, "-");
              headingMap[id] = !isNaN(headingMap[id]) ? ++headingMap[id] : 0;
              if (headingMap[id]) {
                heading.id = id + "-" + headingMap[id];
              } else {
                heading.id = id;
              }
            });
          }
        }); // once
    },
  };
})(Drupal, jQuery);
